import React, { useState } from 'react';
import { Button, Text, TextInput, View } from "../../Components/Themed";
import type { BroadcastResult, BroadcastTarget, FocusPositionProps, ServerInfo } from '../../types';
import { useColors } from '../../constants/useColors';
import { BettorBotApi } from '../api';
import { FlatList, Image } from 'react-native';
import { Icons } from '../../Components';

type BroadcastMessageCardProps = {
    selected_servers: { guild_id:string, channels:string[] }[],
    onClose:() => void,
    servers:ServerInfo[],
    onFocusPosition?:(pos:FocusPositionProps) => void,
    onSendMessage:(results:BroadcastResult[]) => void
}
const BroadcastMessageCard = ({ selected_servers, servers, onSendMessage, onFocusPosition, onClose }:BroadcastMessageCardProps) => {
    const Colors = useColors();
    const [ message, setMessage ] = useState('');
    const [ action_loading, setActionLoading ] = useState(false);
    const [ results, setResults ] = useState<BroadcastResult[]>([]);
    const is_valid = message && selected_servers.length > 0 ? true : false

    const handleSend = async() => {
        if(!is_valid){ return alert('Please enter valid message') }
        if(action_loading){ return }
        setActionLoading(true);
        let targets:BroadcastTarget[] = []
        selected_servers.map(ss => {
            ss.channels.map(c => {
                targets.push({ guild_id: ss.guild_id, channel_id: c })
            });
        });
        console.log(targets);

        const results = await BettorBotApi.broadcastMessage(message, targets);
        let success_results = results.filter(r => r.success);
        let fail_results = results.filter(r => !r.success);
        alert(`Message Sent!\nSuccessful : ${success_results.length}\nFailed: ${fail_results.length}`);
        setResults(results);
    }

    const renderServers = (data:{ item:{ guild_id:string, channels:string[] }, index:number }) => {
        const server = servers.find(s => s.id == data.item.guild_id);
        if(!server){ return <></> }
        return (
            <View float style={{ margin:5, width:100 }}>
                <Image
                    source={{ uri: server.icon ?? '' }}
                    style={{ height:50, width:100, borderTopRightRadius:8, borderTopLeftRadius:8 }}
                    resizeMode='cover'
                />
                <View transparent style={{ padding:10 }}>
                    <Text theme='h1' textAlign='center'>{server.name}</Text>
                    <Text theme='description'>{data.item.channels.length} Channels</Text>
                </View>
            </View>
        )
    }

    const renderResults = (data:{ item:BroadcastResult, index:number }) => {
        const guild = servers.find(s => s.id == data.item.guild_id);
        if(!guild){ return <></> }
        const channel = guild.accessibleChannels.find(c => c.id == data.item.channel_id);
        if(!channel){ return <></> }
        return (
            <View type='row' style={{ borderBottomWidth:1, borderColor:Colors.borders.light, padding:6 }}>
                 <Image
                    source={{ uri: guild.icon ?? '' }}
                    style={{ height:25, width:25 }}
                    resizeMode='cover'
                />
                <View transparent style={{flex:1, marginLeft:10, marginRight:10}}>
                    <Text theme='h1'>{channel.name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{guild.name}</Text>
                </View>
                {data.item.success ?
                <Icons.CheckCirlceIcon size={20} color={Colors.text.success} />
                :
                <Icons.CloseIcon size={20} color={Colors.text.error} />
                }
            </View>
        )
    }

    return (
        <View float style={{ flex:1 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
              <View transparent style={{ flex:1, marginLeft:10 }}>
                <Text theme='h1'>Send Message</Text>
                <Text theme='description' style={{ marginTop:3 }}>Enter your message below and broadcast to {selected_servers.length} servers</Text>
              </View>
              <Button
                float
                title='X'
                title_color={Colors.text.error}
                style={{ padding:10 }}
                onPress={() => {
                    if(results.length > 0){ return onSendMessage(results) }
                    return onClose()
                }}
              />
            </View>
            <View style={{ flex:1, padding:10 }}>
                {results.length == 0 ?
                <View transparent>
                    <TextInput
                        value={message}
                        onFocusPosition={onFocusPosition}
                        placeholder='Enter your message here'
                        onChangeText={(text) => setMessage(text)}
                        style={{ height:150, textAlign:'center' }}
                    />
                </View>
                :
                <FlatList
                    data={results}
                    key='message_results'
                    renderItem={renderResults}
                    keyExtractor={(item) => `${item.guild_id}:${item.channel_id}`}
                />
                }
            </View>
            {results.length == 0 ?
            <View style={{ padding:10 }}>
                <Text theme='h1'>Sending Message To:</Text>
                <FlatList
                    key={'server_list_message'}
                    horizontal
                    renderItem={renderServers}
                    data={selected_servers}
                    keyExtractor={item => item.guild_id}
                />
            </View>
            :<></>}
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
              {results.length == 0 ?
              <Button
                title='SEND MESSAGE'
                type='success'
                disabled={!is_valid || action_loading}
                loading={action_loading}
                style={{ flex:1, opacity: !is_valid ? 0.5 : 1 }}
                onPress={() => handleSend()}
              />
              :
            <Button
                title='CLOSE'
                type='close'
                style={{ flex:1 }}
                onPress={() => onSendMessage(results)}
              />
            }
            </View>
        </View>
    )

}

export default BroadcastMessageCard